import styled, { css, keyframes } from 'styled-components'
import { rem } from 'polished'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'

export const TextContent = styled(Group)`
  min-width: 0;
`

export const TitleRow = styled(Group)`
  min-width: 0;

  > :first-child {
    min-width: 0;
  }

  > button {
    flex-shrink: 0;
  }
`

export const OptionTitle = styled(BodyText)`
  min-width: 0;
  overflow-wrap: anywhere;
`

export const OptionDescription = styled(BodyText)`
  min-width: 0;
  overflow-wrap: anywhere;
`

export const TrailingControl = styled.div`
  display: flex;
  align-self: center;
  flex-shrink: 0;
  align-items: center;
`

const streamingCardReveal = keyframes`
  from {
    opacity: 0;
    transform: translateY(${rem(8)});
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`

export const cardListContainerStyles = css`
  container-name: chat-card-list;
  container-type: inline-size;
  width: 100%;
`

export const StreamingFrame = styled.div`
  ${cardListContainerStyles}
`

export const StreamingSkeletonCard = styled.div`
  padding: ${rem(12)};
  border: 1px solid ${props => props.theme.palette.neutral.default.five};
  border-radius: ${rem(12)};
  cursor: default;
  background-color: transparent;

  &.with-image {
    padding: 0;
    display: flex;
    align-items: stretch;
    overflow: hidden;
  }

  @container chat-card-list (max-width: 480px) {
    padding: ${rem(10)};

    &.with-image {
      padding: 0;
    }
  }
`

export const StreamingCardMount = styled.div`
  &.is-streaming {
    animation: ${streamingCardReveal} 180ms ease-out both;
  }

  @media (prefers-reduced-motion: reduce) {
    &.is-streaming {
      animation: none;
    }
  }
`
